"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.personServiceFactory = void 0;
var realmList_1 = require("./data/realmList");
var fieldAllowlist_1 = require("../src/services/fieldAllowlist");
/**
 * Fields consumed by PHP RowActions::updateRowAction → Person::updateRow.
 * Module-level (not inside personService): the factory returns `service` early via
 * function-declaration hoisting, so const arrays declared after `return service`
 * never run and compile down to `undefined` (TypeError on allowedKeys.length).
 */
var UPDATE_ROW_ALLOWED_KEYS = [
    'ID',
    'pnBody',
    'pnAccount',
    'pnUserRealm',
    'pnAssetAccount',
    'pnAssetRealm',
    'pnAssetTag',
    'pnAssetTagAux',
    'pnUserRoamHint',
    'pnUserRoamPoint',
    'pnUserRoamGeoLat',
    'pnUserRoamGeoLon',
    'pnValue',
    'pnValueUnit',
    'pnParentFK',
    'pnParentAddFK',
    'pnTaskGroup',
    'pnTopicGroup',
    'pnTopicDetail',
    'pnSchedule',
    'pnShareLevel',
    'pnCustomTimeUTC',
    'pnCompletedUTC',
    'pnCompletedPersonPK',
    'pnItemCode',
    'pnInvoiceNote',
];
var UPDATE_REPLY_ALLOWED_KEYS = [
    'ID',
    'pnBody',
    'pnValue',
    'pnValueUnit',
    'pnAssetTag',
    'pnAssetTagAux',
    'pnAssetAccount',
    'pnAssetRealm',
    'pnTaskGroup',
    'pnTopicGroup',
    'pnTopicDetail',
    'pnItemCode',
    'pnParentFK',
    'saveReply',
    'ReplyAsSchedule',
    'ReplyAsAssignedTo',
    'ReplyAsPeer',
    'doneCheck',
];
var UPDATE_ROW_ARRAY_ALLOWED_KEYS = [
    'ID',
    '__closeAtNextStamp',
    '__applyAutoEnd',
    '__clearAutoEnd',
    '__clearCompleted',
];
// personService
// angular.module('audRoamApp').factory('personService',
exports.personServiceFactory = [
    'app.config',
    '$http',
    '$q',
    '$timeout',
    '$rootScope',
    personService,
];
// https://github.com/johnpapa/angular-styleguide/blob/c8839dcb3e4658e6972b75752d1b8c75600565a5/a1/README.md#style-y060
function personService(config, $http, $q, $timeout, $rootScope) {
    var personObject;
    var watchPositionID, currentGeolocation;
    var taskActions;
    var service = {
        login: login,
        fetchRecent: fetchRecent,
        getDailyTally: getDailyTally,
        getDailyTallyWithDetails: getDailyTallyWithDetails,
        getStaleOpen: getStaleOpen,
        getSchedule: getSchedule,
        search: search,
        fetchPerson: fetchPerson,
        getParentList: getParentList,
        getRowById: getRowById,
        getRealmList: getRealmList,
        hideImage: hideImage,
        hideNote: hideNote,
        updateResultRow: updateResultRow,
        getLocation: getLocation,
        currentGeolocation: currentGeolocation,
        startWatchPosition: startWatchPosition,
        stopWatchPosition: stopWatchPosition,
    };
    return service;
    ////
    function backoffDelay(attempt, base, max) {
        if (base === void 0) { base = 1000; }
        if (max === void 0) { max = 10000; }
        var exp = Math.min(max, base * Math.pow(2, Math.max(0, 2 - attempt)));
        var jitter = Math.round(exp * 0.25 * Math.random());
        return exp + jitter;
    }
    function login(args) {
        return $http.post(config.basePath + 'api1.php?json=post', args);
    }
    /**
     * Recent board load. Always attempt the request with a short timeout — do not trust
     * navigator.onLine (misses captive portals, partial DNS, black-hole routes).
     * Failures/timeouts reject; controller keeps IndexedDB paint. No retry on 0/-1/408/504.
     */
    function fetchRecent(viewMode, retries) {
        if (retries === void 0) { retries = 1; }
        if (retries == undefined) {
            retries = 1;
        }
        // set the person object
        return $http
            .post(config.api, { action: 'recent', viewMode: viewMode }, { timeout: 8000 })
            .then(function (response) {
            // Guard against malformed response
            if (!response.data || !response.data.person || !response.data.person.personObject) {
                console.error('fetchRecent: Invalid response structure', response.data);
                return $q.reject(new Error('Invalid recent response structure'));
            }
            personObject = response.data.person.personObject;
            return response;
        }, function (response) {
            // Retry only brief 5xx — never transport/timeout (0, -1, 408, 502–504)
            var status = response && response.status;
            var retriableServer = typeof status === 'number' && status >= 500 && status < 502;
            if (retriableServer && retries-- > 0) {
                var delay = backoffDelay(retries, 800, 3000);
                console.log('fetchRecent - server error - retry in', delay, 'ms');
                return $timeout(function () { return fetchRecent(viewMode, retries); }, delay);
            }
            else {
                console.log('fetchRecent - $http error - promise rejected - returning $q.reject(response)');
                return $q.reject(response);
            }
        });
    }
    /**
     * Fetch schedule board rows (optional server-side filters).
     * @param opts.limit max rows (default 100; 500 for full expand)
     * @param opts.account / opts.realm / opts.q / opts.active
     */
    function getSchedule(opts) {
        var o = typeof opts === 'number' ? { limit: opts } : (opts || {});
        var lim = Math.max(1, Math.min(500, Number(o.limit) || 100));
        var params = ['json=schedule', 'limit=' + encodeURIComponent(String(lim))];
        if (o.account) {
            params.push('account=' + encodeURIComponent(String(o.account)));
        }
        if (o.realm) {
            params.push('realm=' + encodeURIComponent(String(o.realm)));
        }
        if (o.q) {
            params.push('q=' + encodeURIComponent(String(o.q)));
        }
        if (o.active) {
            params.push('active=1');
        }
        return $http.get(config.basePath + 'api1.php?' + params.join('&')).then(function (response) {
            return response.data;
        });
    }
    function search(args) {
        console.log('personService.search()');
        var postArgs = {
            searchArgs: args,
        };
        return $http.post(config.basePath + 'api1.php?json=search', postArgs).then(function (response) {
            return response;
        }, function (response) {
            console.log('search - $http error - promise rejected');
            return $q.reject(response);
        });
    }
    function fetchPerson() {
        console.log('personService.fetchPerson()');
        return $http.get(config.basePath + 'api1.php?json=person').then(function (response) {
            // Guard against malformed response
            if (!response.data || !response.data.person || !response.data.person.personObject) {
                console.error('fetchPerson: Invalid response structure', response.data);
                return $q.reject(new Error('Invalid person response structure'));
            }
            personObject = response.data.person.personObject;
            return response;
        }, function (response) {
            console.log('$http error - promise rejected');
            return $q.reject(response);
        });
    }
    function getParentList() {
        return $http
            .post(config.basePath + 'api1.php?json=parentList', [])
            .then(function (response) {
            return response.data.list;
        });
    }
    function getRowById(id) {
        return $http.post(config.api, { action: 'getRow', id: id });
    }
    function getDailyTally(params) {
        var body = __assign({ action: 'dailyTally' }, (params || {}));
        return $http.post(config.api, body);
    }
    function getDailyTallyWithDetails(params) {
        var body = __assign({ action: 'dailyTally', includeDetails: 1 }, (params || {}));
        return $http.post(config.api, body);
    }
    function getStaleOpen(params) {
        var body = __assign({ action: 'staleOpen' }, (params || {}));
        return $http.post(config.api, body);
    }
    function getRealmList() {
        if (personObject === undefined || personObject === null) {
            return;
        }
        for (var i = 0; i < realmList_1.realmList.length; i++) {
            var realmGroup = realmList_1.realmList[i];
            if (realmGroup && realmGroup.person === personObject.dbPK) {
                return realmGroup.realms;
            }
        }
        return undefined;
    }
    function hideImage(id, filename) {
        return $http
            .post(config.basePath + 'api1.php?json=post', {
            action: 'hideImage',
            id: id,
            filename: filename,
        })
            .then(function (response) {
            return response;
        }, function (response) {
            console.log('hideImage - $q $http error - promise rejected');
            return $q.reject(response);
        });
    }
    function hideNote(id) {
        return $http
            .post(config.basePath + 'api1.php?json=post', {
            action: 'hideNote',
            id: id,
        })
            .then(function (response) {
            return response;
        }, function (response) {
            console.log('hideNote - $q $http error - promise rejected');
            return $q.reject(response);
        });
    }
    function toastAllowlistError(err) {
        var text = (0, fieldAllowlist_1.fieldAllowlistToastText)(err);
        console.error(text, err);
        try {
            $rootScope.$broadcast('ui:toast', {
                text: text,
                type: 'danger',
                timeoutMs: 8000,
            });
        }
        catch (e) {
            console.warn('ui:toast broadcast failed', e);
        }
    }
    function updateResultRow(row) {
        // Allowlist only — never send UI/local-draft metadata (_draft*, Age, etc.).
        // If every non-ID field is stripped, throw + toast (no silent no-op save).
        var cleanRowEdit;
        var cleanReply;
        var cleanRowArray;
        try {
            cleanRowEdit = (0, fieldAllowlist_1.pickAllowedFieldsOrThrow)(row.edit, UPDATE_ROW_ALLOWED_KEYS, 'edit');
            cleanReply = row.reply
                ? (0, fieldAllowlist_1.pickAllowedFieldsOrThrow)(row.reply, UPDATE_REPLY_ALLOWED_KEYS, 'reply')
                : row.reply;
            cleanRowArray = row.rowArray
                ? (0, fieldAllowlist_1.pickAllowedFieldsOrThrow)(row.rowArray, UPDATE_ROW_ARRAY_ALLOWED_KEYS, 'rowArray')
                : row.rowArray;
        }
        catch (err) {
            if (err instanceof fieldAllowlist_1.FieldAllowlistError || (err && err.name === 'FieldAllowlistError')) {
                toastAllowlistError(err);
            }
            return $q.reject(err);
        }
        var args = {
            action: 'updateRow',
            row: cleanRowEdit,
            rowArray: cleanRowArray,
            reply: cleanReply,
            source: 'service-1',
        };
        return $http.post(config.api, args).then(function (response) {
            if (response.data.Result == 'OK') {
                console.log('updateResultRow - OK');
                return response;
            }
            else {
                console.log('updateResultRow - Result = ', response.data.Result);
                return $q.reject(response);
            }
        }, function (response) {
            console.log('updateResultRow - failed');
            return $q.reject(response);
        });
    }
    function watchPosition(positionCallback, errorCallback, options) {
        if (options === undefined) {
            options = {};
        }
        if (navigator.geolocation) {
            return (watchPositionID = navigator.geolocation.watchPosition(positionCallback, errorCallback, options));
        }
        else {
            errorCallback('Geolocation is not available.');
            return false;
        }
    }
    function stopWatchPosition() {
        if (navigator.geolocation) {
            navigator.geolocation.clearWatch(watchPositionID);
            watchPositionID = null;
        }
        else {
            return false;
        }
    }
    function positionError(err) {
        console.warn('ERROR ' + err.code + ': ' + err.message);
    }
    function updatePosition(pos) {
        var crd = pos.coords;
        console.log('POS ' + crd.latitude + ', ' + crd.longitude);
        currentGeolocation = crd;
    }
    function startWatchPosition(callback) {
        if (watchPositionID) {
            console.warn('Already watching position: ' + watchPositionID);
            return watchPositionID;
        }
        var options = {
            enableHighAccuracy: true,
            maximumAge: 30 * 1000,
            timeout: 27 * 1000,
        };
        return watchPosition(callback, positionError, options);
    }
    function getLocation() {
        if (navigator.geolocation) {
            return $q(function (resolve, reject) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    resolve(position);
                }, function (err) {
                    var code = err && err.code;
                    var message = (err && err.message) || 'Location error';
                    if (code === 1) {
                        message =
                            'Location denied — allow location for this site in the browser';
                    }
                    else if (code === 2) {
                        message = 'Location unavailable';
                    }
                    else if (code === 3) {
                        message = 'Location request timed out';
                    }
                    console.warn('getLocation failed:', code, message);
                    reject(new Error(message));
                }, {
                    enableHighAccuracy: true,
                    maximumAge: 30 * 1000,
                    timeout: 27 * 1000,
                });
            });
        }
        else {
            return $q.reject(new Error('Geolocation is not available.'));
        }
    }
}
